<template>
  <div>
    <b-overlay
      :show="loading"
      :variant="'white'"
      :opacity="0.7"
      :blur="'2px'"
      rounded="sm"
      no-wrap
    />
    <div
      v-if="loading && (!annexes || !annexes.length)"
      style="height: 3rem;"
    />
    <div
      v-if="!loading && (!annexes || !annexes.length)"
      class="form-row"
    >
      <div
        class="form-group col"
        style="margin-bottom: 0;"
      >
        <p style="font-size: 0.9rem;">
          {{ $t('datasetDetail.annexes.empty') }}
        </p>
      </div>
    </div>
    <div
      v-for="annexResource of annexes"
      :key="`annex_resource-${annexResource.id}`"
      class="annex_resource"
    >
      <b-overlay
        :show="annexResource.isProcessingPending()"
        :variant="'white'"
        :opacity="0.7"
        :blur="'2px'"
        rounded="sm"
        no-wrap
        style="z-index: 1050;"
      />
      <div v-if="annexResource && (annexResource.isProcessingPending() || annexResource.isProcessingFailed() )">
        <ResourceProcessingAlert
          @resource-processed="resourceProcessed"
          :resource="annexResource"
          :process="annexResource._processing[0]"
          :resource-id="annexResource.id"
          :task-id="annexResource._processing[0].task_id"
        />
      </div>
      <ResourceEditor
        :key="`annex-${annexResource.codename}`"
        :resource="annexResource"
        :is-main="false"
        :dataset="currentDataset"
        :disabled="annexResource.isProcessingPending()"
        v-on="$listeners"
        @delete="openDeleteModal(annexResource)"
      />
      <div
        
        :class="{
          disabled: annexResource.isProcessingPending()
        }"
        class="resource__delete"
      >
        <div />
        <b-button
          variant="danger"
          @click="openDeleteModal(annexResource)"
        >
          {{ $t(`buttons.delete`) }}
        </b-button>
      </div>
      <DeleteResourceModal
        :open="isDeleteResourceModalOpen"
        :resource="annexResource"
        @hide="isDeleteResourceModalOpen = false"
        @delete="deleteResource"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import DeleteResourceModal from '@/components/Resource/modals/DeleteResourceModal.vue';
import ResourceEditor from '@/components/Resource/ResourceEditor.vue';
import ResourceProcessingAlert from '@/components/Resource/ResourceProcessingAlert.vue';

export default {
  name: 'Annexes',

  components: {
    DeleteResourceModal,
    ResourceEditor,
    ResourceProcessingAlert
  },

  props: {
    annexes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      loading: false,
      isDeleteResourceModalOpen: false,
    };
  },

  computed: {
    ...mapState('datasets', [
      'currentDataset'
    ]),
  },

  watch: {

  },

  async created() {
    
  },

  methods: {

    ...mapActions('resources', [
      'DELETE_RESOURCE'
    ]),

    openDeleteModal(annexResource) {
      this.isDeleteResourceModalOpen = true;
    },

    resourceProcessed(resource) {
      console.log('resourceProcessed',resource);
    },

    deleteResource(ressource) {
      this.DELETE_RESOURCE(ressource)
        .then(() => {
           this.$emit('delete', ressource);
         
        })
        .catch((err) => {
          console.error(err);
        });
     
       
    }
  }
};
</script>
